export default __webpack_public_path__ + "static/media/teamwork.39f31faa.svg";